module.exports = __webpack_public_path__ + "img/khgl.fe2875bd.png";